export default __webpack_public_path__ + "static/media/Artist5.f1dd0bab.svg";